import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const getRole = createAsyncThunk('roleSlice/getRole', async () => {
    try {
        let response = await axios.get('/role', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getRoleOptions = createAsyncThunk('roleSlice/getRoleOptions', async () => {
    try {
        let response = await axios.get('/role/options', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        let options = response?.data?.data || [];

        return Promise.resolve(options);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createRole = createAsyncThunk('roleSlice/createRole', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/role', data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Role added successfully.');
        dispatch(getRole());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getRoleById = createAsyncThunk('roleSlice/getRoleById', async (id) => {
    try {
        let response = await axios.get('/role/' + id, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateRole = createAsyncThunk('roleSlice/updateRole', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/role/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Role updated successfully.');
        dispatch(getRole());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteRole = createAsyncThunk('roleSlice/deleteRole', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/role/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Role deleted successfully.');
        dispatch(getRole());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateStatus = createAsyncThunk('roleSlice/updateStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/role/status/' + id, undefined, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getRole());

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const updateLevelRole = createAsyncThunk('roleSlice/updateLevelRole', async (data, { dispatch }) => {
    try {
        let response = await axios.post(
            '/role/update-level',
            { roleIds: data },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                loader: true
            }
        );
        toast.success(response?.data?.message || 'Role Level updated successfully.');
        dispatch(getRole());
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const roleSlice = createSlice({
    name: 'roleSlice',
    initialState: {
        data: [],
        options: [],
        selectedRole: {}
    },
    reducers: {
        handleSelectedRole: (state, action) => {
            state.selectedRole = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRole.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getRoleOptions.fulfilled, (state, action) => {
            state.options = action.payload;
            return;
        });
        builder.addCase(getRoleById.fulfilled, (state, action) => {
            state.selectedRole = action.payload;
            return;
        });
    }
});

export const { handleSelectedRole } = roleSlice.actions;

export default roleSlice.reducer;
